/** @jsx jsx */
/** @jsxFrag Fragment */
import { css, jsx } from '@emotion/react';
import React, { Fragment, useState } from 'react';
import { TableListHeader } from '../../_shared/table-list';
import { message } from 'antd';
import { Button } from '../../_shared/button';
import { Select } from '../../_shared/select';
import { useSelector } from 'react-redux';
import styles from './styles';
import { size, get } from 'lodash';
import { generateTechDataReport } from '../../_shared/services/analytics.service';
import { Loading } from '../../_shared/icon';
import { Column } from '../../_shared/row';
import defaultStyles from '../../_shared/styles';
import { sortByLabel } from '../../utils';

const Status = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Both', value: 'any' },
].sort(sortByLabel)

const OrgTypes = [
  { label: 'None (all)', value: 'none' },
  { label: 'Dental Org', value: 'dentalorg' },
  { label: 'Service Org', value: 'serviceorg' },
  { label: 'Admin', value: 'admin' },
  { label: 'Manufacturing', value: 'manufacturing' },
].sort(sortByLabel)

export const UserReports = (props = {}) => {
  const user = useSelector(s => get(s, 'auth.user'));

  const [state, setState] = useState({
    loading: false,
    data: [],
    input: '',
    selFilters: {
    },
    filters: [
      {
        id: 'userState',
        opts: Status,
        props: {
          placeholder: 'Status',
          mode: 'default',
        },
      },
      {
        id: 'userType',
        //@ts-ignore
        opts: (s) => OrgTypes,
        //@ts-ignore
        props: (opts = {}) => ({
          placeholder: 'Org Type',
          mode: 'default',
        }),
      },
    ],
  });

  const retrieveData = async () => {
    try {
      setState(s => ({ ...s, loading: true, data: [] }));

      const data = (await generateTechDataReport({
        user,
        ...state.selFilters,
      }, 'UserData'))

      setState(s => ({
        ...s,
        data,
      }));
    } catch (err) {
      const msg = err.message;
      if ((msg || '').toLowerCase().indexOf('network error') > -1) {
        message.info('The network request has timed out, but your report is still being generated and will be sent to your email.')
      } else {
        message.error(`Failed to generate report: ${err.message}`);
      }
    } finally {
      setState(s => ({ ...s, loading: false }));
    }
  };

  const changeSelect = (filt: string, values: string[]) => {
    //@ts-ignore
    setState(s => ({ 
      ...s, 
      data: [],
      selFilters: {
        ...s.selFilters, 
        [filt]: values 
      } 
    }));
  };

  const { loading, data } = state;

  const deps = [
    'selFilters.userState',
    'selFilters.userType',
  ]

  const canRun = size(deps.filter(d => get(state, d))) >= size(deps);

  return (
    <div style={{ height: '100%' }}>
      <TableListHeader style={`justify-content: flex-start;`}>
        {state.filters.map((filt: any) => {
          return (
            <Select
              key={filt.id}
              mode="multiple"
              css={css(styles.select)}
              onChange={value => changeSelect(filt.id, value as string[])}
              filterOption={(input, option) => {
                const name = option!.props.children as string;
                if (name)
                  return name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                return true;
              }}
              value={get(state, `selFilters.${filt.id}`)}
              {...(typeof filt.props == 'function' ? filt.props({ state }) : filt.props || {})}
            >
              {(typeof filt.opts == 'function' ? filt.opts({ state }) : filt.opts || []).map(
                (item: { label: string; value: string | number }) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              )}
            </Select>
          );
        })}

        <Button title="Run Report" disabled={!canRun} onClick={retrieveData} />
      </TableListHeader>

      <Column center fullHeight>
        {loading ? <>
          <Loading />
          <p css={css(styles.generateText)}>Generating your report. You will receive an email when it finishes.</p>
        </> : <>
          <p css={css(defaultStyles.header)}>User Analytics Data Report</p>
          <p css={css(styles.generateText)}>Use the filters above to define the query, and then select 'Run Report'.  The results will be emailed to you within a few minutes.</p>
          {!!get(data, 'url') && <div style={{ textAlign: 'center', marginTop: 20 }}><a href={get(data, 'url')} target='_blank'>Download Report</a></div>}
        </>}
      </Column>

      {!!get(data, 'url') && <div style={{ textAlign: 'center', marginTop: 20 }}><a href={get(data, 'url')} target='_blank'>Download Report</a></div>}
    </div>
  );
};
